// Object
import "core-js/features/object/assign";
import "core-js/features/object/keys";
import "core-js/features/object/values";

// Number
import "core-js/features/number/is-integer";
import "core-js/features/number/is-nan";
import "core-js/features/number/parse-float";
import "core-js/features/number/parse-int";

// Array
import "core-js/features/array/every";
import "core-js/features/array/includes";
import "core-js/features/array/fill";
import "core-js/features/array/find";
import "core-js/features/array/find-index";
import "core-js/features/array/from";
import "core-js/features/array/map";
import "core-js/features/array/some";
import "core-js/features/array/filter";

// String
import "core-js/features/string/includes";
import "core-js/features/string/starts-with";

// Set
import "core-js/features/set";

// URL
import "core-js/features/url";

// Promise
import "core-js/features/promise";

// Symbol
import "core-js/features/symbol/async-iterator";
import "core-js/features/symbol/for";
